interface Props {
  providerName: string;
  lastUpdate: string;
}
export const ProviderNameMobile: React.FC<Props> = ({providerName,lastUpdate})=>{
  return (
    <div className="flex-1">
      <span className="text-sm mr-2">{providerName}:</span>
      <span className="text-text-secondary text-sm">{lastUpdate}</span>
    </div>
  )
}